import { homeMenu } from './home';
import { MenuItem } from '../../../commons/ui/menu';
import { promotionOperationMenu } from './PromotionOperation';

export const routes: MenuItem[] = [homeMenu, promotionOperationMenu];
